module.exports = __webpack_public_path__ + "img/colorado-21.579cf7a1.png";